import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'sushiweb/Modal/Modal';
import {
    ClickableText,
    ModalContentContainer,
    ModalHeader,
    ModalTitle,
    ModalContent,
    ModalList,
    ModalListItem,
    ModalListItemText,
    ModalFooter,
    ModalCloseButton,
} from './styles';

const ListInfoModal = ({
    items,
    itemLabel,
    modalTitle,
    getItemText,
    renderIcon,
}) => {
    const [visible, setVisible] = useState(false);

    if (!items?.length) return 'NA';

    const pluralLabel = items.length > 1 ? `${itemLabel}s` : itemLabel;

    return (
      <>
        <ClickableText
          onClick={() => setVisible(true)}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
                setVisible(true);
            }
          }}
        >
          {`${items.length} ${pluralLabel}`}
        </ClickableText>

        <Modal
          visible={visible}
          onClose={() => setVisible(false)}
          isCentered
          type="flex"
          borderRadius="12px"
        >
          <ModalContentContainer>
            <ModalHeader>
              <ModalTitle>{modalTitle}</ModalTitle>
            </ModalHeader>

            <ModalContent>
              <ModalList>
                {items.map((item, idx) => (
                  <ModalListItem
                    key={item?.id || idx}
                    gap="15px"
                    isLast={idx === items.length - 1}
                  >
                    {renderIcon()}
                    <ModalListItemText>
                      {getItemText(item)}
                    </ModalListItemText>
                  </ModalListItem>
                ))}
              </ModalList>
            </ModalContent>

            <ModalFooter>
              <ModalCloseButton onClick={() => setVisible(false)}>
                Go Back
              </ModalCloseButton>
            </ModalFooter>
          </ModalContentContainer>
        </Modal>
      </>
    );
};

ListInfoModal.propTypes = {
    items: PropTypes.arrayOf(PropTypes.any),
    itemLabel: PropTypes.string.isRequired,
    modalTitle: PropTypes.string.isRequired,
    getItemText: PropTypes.func.isRequired,
    renderIcon: PropTypes.func.isRequired,
};

ListInfoModal.defaultProps = {
    items: [],
};

export default ListInfoModal;
